import { Box, Stack, Typography } from "@mui/material"
import { ThemeContext } from "../../../Shared/Theme/ThemeContext"
import { useContext } from "react";

export function MapButton({...params}){

    const { mode } = useContext(ThemeContext);

    let mapButtonState = params.mapButtonState
    let setMapButtonState = params.setMapButtonState
    let handleClick = params.handleClick

    let lightPaths = ["/icons/icons-light/icon-map-light-active.svg", "/icons/icons-light/icon-map-light-default.svg", "/icons/icons-light/icon-map-light-hover.svg"]
    let darkPaths = ["/icons/icons-dark/icon-map-dark-active.svg", "/icons/icons-dark/icon-map-dark-default.svg", "/icons/icons-dark/icon-map-dark-hover.svg"]

    let lightColors = ["#02203B", "#06569D", "#138BF6"]
    let darkColors = ["#138BF6", "#75BCFA", "#D8ECFD"]

    let onButtonPage = false
    let url = window.location.pathname
    if (url === '/mappage') onButtonPage = true

    const handleButtonHover = (event) => {
        event.preventDefault()
        if (onButtonPage) setMapButtonState('hover')
        else if (mapButtonState !== 'active') setMapButtonState('hover')
    }

    const handleButtonMouseOut = (event) => {
        event.preventDefault()
        setMapButtonState('default')
        if (onButtonPage) setMapButtonState('active')
        else if (mapButtonState !== 'active') setMapButtonState('default')
    }

    let imagePath = ''
    let labelColor = ''

    if (mode === 'light'){
        if (mapButtonState === 'active') {imagePath = lightPaths[0]; labelColor = lightColors[0]}
        else if (mapButtonState === 'default') {imagePath = lightPaths[1]; labelColor = lightColors[1]}
        else if (mapButtonState === 'hover') {imagePath = lightPaths[2]; labelColor = lightColors[2]}
    } 
    else if (mode === 'dark'){
        if (mapButtonState === 'active') {imagePath = darkPaths[0]; labelColor = darkColors[0]}
        else if (mapButtonState === 'default') {imagePath = darkPaths[1]; labelColor = darkColors[1]}
        else if (mapButtonState === 'hover') {imagePath = darkPaths[2]; labelColor = darkColors[2]}
    } 

    let labelFormatting = params.labelFormatting
    let labelStyling = {color: labelColor, width: '29px', height: '10px'}

    return (
        <Stack width={'71px'} height={'55px'} direction={'column'} alignItems={'center'} zIndex={100}
            onMouseOut={(event) => handleButtonMouseOut(event)} 
            onMouseOver={(event) => handleButtonHover(event)}
            onClick={(event) => handleClick(event)}>

            <Box component="img" src={imagePath} width={'35px'} height={'45px'} paddingBottom={'10px'}  id={"MapButton"}/>
            <Typography sx={[labelFormatting, labelStyling]}>Map</Typography>
        </Stack>
    )
}
